import testPhoto from "../assets/img/testPhoto.jpg"
import { Col, Row, Image } from "react-bootstrap";

export const Newsletter = () => {

  return (
    <Col lg={12}>
      <div className="newsletter-bx wow slideInUp">
      <h1 class="text-center text-4xl font-bold mb-5 text-gray-900 sm:text-6xl">
          What clients says about me ?
        </h1>
        <Row>
          <Col lg={12} md={6} xl={6}>
            <section className="px-2 py-10 md:px-0">
              <div className="mx-auto max-w-4xl">
                <div className="md:flex text-center md:items-center md:justify-center md:space-x-14">
                  <div className="relative flex-shrink-0">
                    <Image
                      className="relative object-cover"
                      src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&amp;ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlcnxlbnwwfHwwfHw%3D&amp;auto=format&amp;fit=crop&amp;w=800&amp;q=60"
                      alt=""
                      roundedCircle
                    />
                  </div>
                  <div className="mt-10 md:mt-0">
                    <blockquote>
                      <p class="text-xl text-black text-center">
                      "Working with Deepankar was a revelation! Their adeptness in both front-end and back-end development ensured a flawless project execution, exceeding expectations at every turn."
                      </p>
                    </blockquote>
                    <p class="mt-7 text-lg font-semibold text-black">Greeley Sen</p>
                    <p class="mt-0 text-base text-gray-600">Managing Director at Soften, Netherland</p>
                  </div>
                </div>
              </div>
            </section>

          </Col>
          <Col lg={12} md={6} xl={6}>
            <section className="px-2 py-10 md:px-0">
              <div className="mx-auto max-w-4xl">
                <div className="md:flex text-center md:items-center md:justify-center md:space-x-14">
                  <div className="relative flex-shrink-0">
                    <Image
                      className="relative object-cover"
                      src={testPhoto}
                      alt=""
                      roundedCircle
                    />
                  </div>
                  <div class="mt-10 md:mt-0">
                    <blockquote>
                      <p class="text-xl text-black text-center">
                      "Collaborating with Mr. Sahu was a seamless experience! Their expertise in crafting elegant interfaces and robust backend systems made our project a resounding success."
                      </p>
                    </blockquote>
                    <p class="mt-7 text-lg font-semibold text-black">Caroline Wangate</p>
                    <p class="mt-0 text-base text-gray-600">Managing Director at Ranxny, France</p>
                  </div>
                </div>
              </div>
            </section>
          </Col>
        </Row>
      </div>
    </Col>
  )
}
